<template>
  <panel class="mt-5" :title="'Documents to download' | translate" :no-button="true">
    <thux-list-component
      :fields="getFields"
      :pagination="getPaginationFields"
      @select-per-page="changePerPage"
      @change-page="changePage"
      :action-select="getActionSelectFields"
      @select-action="setAction"
      @select-or-deselect-all-queryset="selectOrDeselectAllQueryset"
      @do-action="doAction($event, fieldName)"
      :advanced-search="getAdvancedSearchFields"
      @show-advanced-search="openAdvancedSearch"
      @open-edit-form="openEditForm()"
      @open-detail-form="openDetailForm()"
    >
      <template slot="body">
        <component-table
          :list="list.results"
          :goBack="goBack"
          :params="tableParams"
        />
      </template>
    </thux-list-component>
  </panel>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import ThuxListMixin from '@/components/thux-list/ThuxListMixin'
import { TYPES as DOCUMENT_TO_DOWNLOAD_TYPES } from './store'

import DocumentToDownloadTable from './DocumentToDownloadTable'

export default {
  name: 'DocumentToDownloadPanel',
  props: { yardId: {} },
  mixins: [ThuxListMixin],
  components: {
    'component-table': DocumentToDownloadTable
  },
  data () {
    return {
      editComponent: false,
      detailComponent: false,
      showCommonFilters: false
    }
  },
  computed: {
    ...mapGetters({
      ...DOCUMENT_TO_DOWNLOAD_TYPES.GENERIC.document.documentdownloadable.LIST.GETTERS
    })
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
      ...DOCUMENT_TO_DOWNLOAD_TYPES.GENERIC.document.documentdownloadable.LIST.ACTIONS
    })
  }
}
</script>
